
const columnNames = [
  'dateCreatedDecomposed',
  'accountId',
  'metadata',
  'dateCreated',
  'wordCount',
  'length',
  'classifiers',
  'mediaContentType',
  'mediaId',
  'formatVersion',
  'status',
  'turns',
  '_score',
];
(async () => {
  // TODO: Implement describe method once it exists and populate here. For now keep the
  // default properties, we'll be missing other categories but not sure if they should be
  // able to be referenced here.
  // columnNames = await fetch('columns');
  columnNames.push.apply(columnNames, [
    'TODOcategory',
    'TODOcategory',
  ]);
  columnNames.sort();
})();

export default columnNames;
